var _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8, _stop9, _stop10, _stop11, _stop12, _stop13, _stop14, _stop15, _stop16, _stop17, _stop18, _stop19, _stop20, _stop21, _stop22, _feOffset, _feGaussianBlur, _feColorMatrix, _feMerge, _rect, _path, _text, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgCreateNewBiteBtn(props) {
  const _id12 = useUniqueInlineId();
  const _id11 = useUniqueInlineId();
  const _id10 = useUniqueInlineId();
  const _id9 = useUniqueInlineId();
  const _id8 = useUniqueInlineId();
  const _id7 = useUniqueInlineId();
  const _id6 = useUniqueInlineId();
  const _id5 = useUniqueInlineId();
  const _id4 = useUniqueInlineId();
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 154,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "96.597%",
    y1: "50%",
    x2: "50.255%",
    y2: "-.844%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF7FE",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFFF",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.274%",
    y1: "-.844%",
    x2: "50.274%",
    y2: "97.755%",
    id: _id2
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A7FD",
    offset: "0%"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4600DB",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "99.063%",
    x2: "50%",
    y2: "0%",
    id: _id3
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9",
    offset: "0%"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1253FA",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: ".377%",
    x2: "50%",
    y2: "100%",
    id: _id4
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17C868",
    offset: ".019%"
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62BD00",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.162%",
    y1: "9.66%",
    x2: "22.6%",
    y2: "85.307%",
    id: _id5
  }, _stop9 || (_stop9 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1",
    offset: "0%"
  })), _stop10 || (_stop10 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C27",
    offset: "99.918%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.162%",
    y1: "33.64%",
    x2: "22.6%",
    y2: "64.319%",
    id: _id6
  }, _stop11 || (_stop11 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12E3FA",
    offset: "0%"
  })), _stop12 || (_stop12 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4277FF",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "72.841%",
    y1: "7.565%",
    x2: "22.981%",
    y2: "87.141%",
    id: _id7
  }, _stop13 || (_stop13 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1",
    offset: "0%"
  })), _stop14 || (_stop14 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C27",
    offset: "99.918%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.568%",
    y1: "7.565%",
    x2: "35.133%",
    y2: "87.141%",
    id: _id8
  }, _stop15 || (_stop15 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1",
    offset: "0%"
  })), _stop16 || (_stop16 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C27",
    offset: "99.918%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.162%",
    y1: "7.565%",
    x2: "22.6%",
    y2: "87.141%",
    id: _id9
  }, _stop17 || (_stop17 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1",
    offset: "0%"
  })), _stop18 || (_stop18 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C27",
    offset: "99.918%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.175%",
    y1: "7.565%",
    x2: "35.598%",
    y2: "87.141%",
    id: _id10
  }, _stop19 || (_stop19 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9900",
    offset: "0%"
  })), _stop20 || (_stop20 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE6700",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "71.66%",
    y1: "7.565%",
    x2: "24.377%",
    y2: "87.141%",
    id: _id11
  }, _stop21 || (_stop21 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC54BE",
    offset: "0%"
  })), _stop22 || (_stop22 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5802D5",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-59.8%",
    y: "-46.5%",
    width: "219.6%",
    height: "193.1%",
    filterUnits: "objectBoundingBox",
    id: _id12
  }, _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    dy: 13,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.850980392 0 0 0 0 0.850980392 0 0 0 0 0.850980392 0 0 0 1 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  })), _feMerge || (_feMerge = /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    fillRule: "nonzero",
    width: 330,
    height: 154,
    rx: 29
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#".concat(_id12, ")"),
    transform: "rotate(-18 174.275 -70.275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.394 6.475c7.362 0 13.33 6.183 13.33 13.808 0 7.623-5.962 13.803-13.321 13.809-7.36-.006-13.325-6.184-13.33-13.809h-.009c0-7.625 5.968-13.808 13.33-13.808",
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.155 0H1.558C1.171.058.82.26.563.565l-.494.457A4.71 4.71 0 000 1.793c0 3.04 3.29 3.345 3.29 3.345 1.893.464 3.196 2.264 3.098 4.277.002.367-.036.734-.112 1.094a4.382 4.382 0 00-.45 1.874c0 2.394 2.596 3.21 2.596 3.21 1.412.672 2.31 2.139 2.294 3.747a5.52 5.52 0 01-.441 2.152 3.945 3.945 0 00-.866 2.34c0 1.973 2.008 3.094 2.008 3.094a4.2 4.2 0 011.567 3.228 5.423 5.423 0 01-.952 2.923 3.516 3.516 0 00-1.394 2.69 4.36 4.36 0 001.394 2.878c.61.756.954 1.704.978 2.69a5.088 5.088 0 01-1.584 3.497c-1.16.485-1.932 1.637-1.965 2.932.037.905.34 1.778.866 2.501.31.645.477 1.352.493 2.072 0 2.51-2.346 3.846-2.346 3.846-2.077.646-2.597 2.018-2.597 3.174a5.2 5.2 0 00.399 1.919c.103.42.155.85.155 1.282 0 3.156-3.142 4.116-3.142 4.116C.485 66.862 0 68.853 0 70.108c-.002.32.027.637.087.95l.441.413c.291.28.655.465 1.048.529h34.588c10.919.037 19.8-9.1 19.836-20.411.019-6.007-2.509-11.72-6.913-15.625 8.26-7.388 9.175-20.314 2.043-28.872C47.376 2.588 41.915 0 36.172 0h-.017m1.195 6.133c7.362 0 13.33 6.182 13.33 13.808 0 7.622-5.962 13.803-13.321 13.808-7.36-.005-13.325-6.184-13.33-13.808h-.009c0-7.626 5.967-13.808 13.33-13.808",
    fill: "url(#".concat(_id2, ")")
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.886 15.342c2.442 0 4.421 2.015 4.421 4.5 0 2.486-1.979 4.5-4.42 4.5-2.442 0-4.422-2.014-4.422-4.5 0-.435.061-.856.175-1.255.26.179.572.283.909.283.901 0 1.632-.744 1.632-1.662 0-.492-.21-.935-.545-1.24a4.335 4.335 0 012.25-.626z",
    fill: "#1D1D1B"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arimo-Bold, Arimo",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#1253FA",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 116,
    y: 85
  }, "Create your first Bite"))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.549
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.26 125.644h19v19h-19z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.917 2.375h3.166a6.333 6.333 0 010 12.667v2.77c-3.958-1.583-9.5-3.958-9.5-9.104a6.333 6.333 0 016.334-6.333zM9.5 13.458h1.583a4.75 4.75 0 100-9.5H7.917a4.75 4.75 0 00-4.75 4.75c0 2.858 1.949 4.723 6.333 6.714v-1.964z",
    fill: "url(#".concat(_id3, ")"),
    fillRule: "nonzero",
    transform: "translate(130.26 125.644)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.26 114.644h16v16h-16z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.667 2h2.666a5.333 5.333 0 110 10.667V15c-3.333-1.333-8-3.333-8-7.667A5.333 5.333 0 016.667 2zM8 11.333h1.333a4 4 0 100-8H6.667a4 4 0 00-4 4c0 2.407 1.641 3.978 5.333 5.654v-1.654z",
    fill: "url(#".concat(_id4, ")"),
    fillRule: "nonzero",
    transform: "translate(142.26 114.644)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.26 124.644h-19v19h19z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.917 2.375h3.166a6.333 6.333 0 010 12.667v2.77c-3.958-1.583-9.5-3.958-9.5-9.104a6.333 6.333 0 016.334-6.333zM9.5 13.458h1.583a4.75 4.75 0 100-9.5H7.917a4.75 4.75 0 00-4.75 4.75c0 2.858 1.949 4.723 6.333 6.714v-1.964z",
    fill: "url(#".concat(_id5, ")"),
    transform: "matrix(-1 0 0 1 172.26 124.644)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.123 0c.847 0 1.536.697 1.536 1.554v26.41h1.535c.283 0 .512.232.512.518 0 .286-.23.518-.512.518H16.512a.515.515 0 01-.512-.518c0-.286.23-.518.512-.518h1.535V17.09c0-.856.689-1.553 1.535-1.553h2.048c.846 0 1.535.697 1.535 1.553v10.875h2.047V6.732c0-.857.688-1.553 1.535-1.553h2.047c.847 0 1.535.696 1.535 1.553v21.232h2.048V11.911c0-.857.688-1.554 1.535-1.554h2.047c.846 0 1.535.697 1.535 1.554v16.053h2.047V1.554C39.541.697 40.23 0 41.076 0h2.047zM21.63 16.572h-2.048a.516.516 0 00-.511.517v10.875h3.07V17.09a.516.516 0 00-.511-.517zm7.164-10.357h-2.047a.515.515 0 00-.512.517v21.232h3.07V6.732a.515.515 0 00-.511-.517zm7.165 5.178h-2.047a.516.516 0 00-.512.518v16.053h3.07V11.911a.516.516 0 00-.511-.518zm7.164-10.357h-2.047a.515.515 0 00-.511.518v26.41h3.07V1.554a.515.515 0 00-.512-.518zM7.5 7.5a.75.75 0 01.75.75v6h6A.75.75 0 0115 15c0 4.136-3.364 7.5-7.5 7.5S0 19.136 0 15s3.365-7.5 7.5-7.5zm-.75 1.547A6.008 6.008 0 001.5 15c0 3.308 2.692 6 6 6a6.01 6.01 0 005.954-5.25H7.5a.75.75 0 01-.75-.75V9.047zM10.5 4.5c4.136 0 7.5 3.364 7.5 7.5a.75.75 0 01-.75.75H10.5a.75.75 0 01-.75-.75V5.25a.75.75 0 01.75-.75zm.75 1.547v5.203h5.203a6.013 6.013 0 00-5.203-5.203z",
    transform: "translate(176.26 109.644)",
    fill: "url(#".concat(_id6, ")")
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(98 109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.762 2.713c-7.188 0-12.995 5.819-12.995 13.02l.005.329c.065 2.52.885 5.022 2.342 7.145l.015.018.005.04-2.39 5.643 5.689-2.419-.132-.088c2.254 1.552 4.752 2.352 7.461 2.352 7.189 0 12.995-5.818 12.995-13.02 0-7.201-5.806-13.02-12.995-13.02zm0 1.24c6.503 0 11.755 5.263 11.755 11.78 0 6.518-5.252 11.78-11.755 11.78l-.333-.004c-2.215-.06-4.264-.715-6.143-1.94l-.136-.092-.017-.027a.741.741 0 00-.366-.263.997.997 0 00-.377-.048l-.086.01a.802.802 0 00-.497.246l-.017.021-2.708 1.151 1.295-3.057v-.126c0-.148-.004-.241-.025-.365l-.023-.113a1.04 1.04 0 00-.188-.4l-.017-.019.013.019c-1.38-2.01-2.13-4.395-2.13-6.773 0-6.517 5.252-11.78 11.755-11.78z",
    fill: "url(#".concat(_id7, ")"),
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.783 19.838c-.263 0-.525-.264-.525-.527v-3.028c0-.264.262-.527.525-.527 1.577 0 2.891-1.317 2.891-2.897 0-1.58-1.314-2.897-2.89-2.897-1.578 0-2.892 1.317-2.892 2.897 0 .263-.263.527-.525.527-.263 0-.526-.264-.526-.527 0-2.238 1.84-4.082 4.074-4.082s4.073 1.844 4.073 4.082c0 1.975-1.445 3.687-3.416 3.95v2.502c-.263.263-.526.527-.789.527z",
    fill: "url(#".concat(_id8, ")")
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#".concat(_id9, ")"),
    cx: 15.887,
    cy: 22.087,
    r: 1.163
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 21V6.2a3 3 0 013-3h1.027c.164-.464.599-.8 1.114-.8h1.186C6.327 1.077 7.391 0 8.7 0c1.308 0 2.373 1.077 2.373 2.4h1.186c.515 0 .95.336 1.114.8H14.4a3 3 0 013 3V21a3 3 0 01-3 3H3a3 3 0 01-3-3zM8.7.8c-.872 0-1.582.718-1.582 1.6h3.164c0-.882-.71-1.6-1.582-1.6zm3.955 4.4V3.6a.4.4 0 00-.396-.4H5.141a.398.398 0 00-.396.4v2h7.91v-.4zm.395 1.2h-8.7a.398.398 0 01-.395-.4v-.4h-.582a1 1 0 00-1 1v14a1 1 0 001 1h10.654a1 1 0 001-1v-14a1 1 0 00-1-1h-.582V6c0 .221-.177.4-.395.4zM14.61 4h-1.165v.8h.373a2 2 0 012 2v13.6a2 2 0 01-2 2H3.582a2 2 0 01-2-2V6.8a2 2 0 012-2h.373V4H2.79a2 2 0 00-2 2v15.2a2 2 0 002 2h11.818a2 2 0 002-2V6a2 2 0 00-2-2zM7.842 17.422a.395.395 0 01-.63.038l-2.372-2.8a.402.402 0 01.042-.564.39.39 0 01.558.044l2.033 2.399 4.456-6.761a.393.393 0 01.549-.11c.181.122.23.37.11.554l-4.746 7.2zM8.98 1.316a.416.416 0 01.114.284.423.423 0 01-.114.284A.413.413 0 018.7 2a.413.413 0 01-.28-.116.423.423 0 01-.115-.284c0-.108.043-.208.114-.284a.41.41 0 01.562 0z",
    transform: "rotate(-19 469.343 -686.739)",
    fill: "url(#".concat(_id10, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.78 1.32L20 4.808v.307l-.061.077-.083.154a.426.426 0 01-.06.077L4.8 10.551h15.91c.204 0 .51.206.51.514v9.026c0 1.026-.814 1.847-1.933 1.847H3.223c-1.016 0-1.931-.82-1.931-1.847v-8.924l-1.22-3.59c-.102-.41-.102-.923.101-1.333.204-.41.61-.821 1.017-.924L16.44.09c.916-.309 2.034.204 2.34 1.23zm1.626 10.155h-18.2v8.616c0 .513.407.924 1.017.924H19.39c.508 0 1.017-.41 1.017-.924v-8.616zm-9.252 6.462v.923h-5.49v-.923h5.49zm5.693-2.154v.923H5.664v-.923h11.183zm0-2.154v.923H5.664v-.923h11.183zM2.465 5.74l-.868.298c-.305.206-.407.308-.509.513a.883.883 0 000 .718l1.053 2.897.324-4.426zm2.857-.98l-1.918.658-.333 4.632 2.002-.685.249-4.605zm2.849-.977l-1.916.657-.34 4.636 2.002-.685.254-4.608zm2.833-.972l-1.895.65-.253 4.61 1.813-.622.335-4.638zm2.849-.978l-1.9.652-.253 4.611 1.813-.62.34-4.643zm2.844-.976l-1.904.654-.335 4.641 1.905-.652.334-4.643zm.92.044l-.315 4.278 1.985-.68-1.118-3.076A1.085 1.085 0 0017.616.9z",
    fill: "url(#".concat(_id11, ")"),
    transform: "rotate(9 -656.378 1514.55)"
  })));
}
export default SvgCreateNewBiteBtn;